import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { BrowserRouter, Switch } from 'react-router-dom';
import { Route } from 'react-router';
import { tokenInterceptor } from '@prime/auth';
import App from './App';
import * as serviceWorker from './serviceWorker';
import i18n from './App/core/i18n/i18n';
import rootReducer from './App/core/redux/rootReducer';
import rootSaga from './App/core/redux/rootSaga';
import { APP_CONFIG } from './config/appConfig';
import { ROLES } from './App/core/auth/enums/roles';
import { ROUTES } from './App/core/router/routes';
import NotFound from './App/core/error/NotFound';
import AccessDenied from './App/core/error/AccessDenied';
import Unauthorized from './App/core/error/Unauthorized';
import Unavailable from './App/core/error/Unavailable';
import AuthProvider from './App/core/auth/AuthProvider/AuthProvider';
import OAuthClient from './App/core/auth/AuthProvider/OAuthClient';
import ProtectedRoute from './App/core/router/ProtectedRoute';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer(history), applyMiddleware(sagaMiddleware, routerMiddleware(history)));

sagaMiddleware.run(rootSaga);

axios.defaults.withCredentials = true;
axios.defaults.baseURL = APP_CONFIG.API_HOST;
axios.interceptors.request.use(tokenInterceptor(OAuthClient));

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <I18nextProvider i18n={i18n}>
          <Switch>
            <Route exact path={ROUTES.ERROR_401} component={Unauthorized} />
            <AuthProvider OAuthClient={OAuthClient}>
              <Switch>
                <Route exact path={ROUTES.ERROR_404} component={NotFound} />
                <Route exact path={ROUTES.ERROR_403} component={AccessDenied} />
                <Route exact path={ROUTES.ERROR_503} component={Unavailable} />
                <ProtectedRoute path={ROUTES.DEFAULT} component={App} allowedRoles={[ROLES.ROLE_ADMIN]} />
              </Switch>
            </AuthProvider>
          </Switch>
        </I18nextProvider>
      </ConnectedRouter>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
